import { render, staticRenderFns } from "./CatalogShareModal.vue?vue&type=template&id=01849c8a&scoped=true"
import script from "./CatalogShareModal.vue?vue&type=script&lang=js"
export * from "./CatalogShareModal.vue?vue&type=script&lang=js"
import style0 from "./CatalogShareModal.vue?vue&type=style&index=0&id=01849c8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01849c8a",
  null
  
)

export default component.exports